








































import { Text, isExperienceEditorActive, RichText } from '@sitecore-jss/sitecore-jss-vue';
import SitecoreMultiline from '../../Sitecore/SitecoreMultiline.vue';
import BasePromoCard from '../base-component/_BasePromoCard.vue';
import { generateCentrelinkScheduleRequest } from '../../../api';
import { apiErrorHelper } from '../../../api/apiErrorHelper';

export default {
  name: 'CentrelinkCard',
  components: {
    ScText: Text,
    ScRichText: RichText,
    BasePromoCard,
    SitecoreMultiline,
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
    dialogWidth() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 345;
      }
      return 576;
    },
    policies() {
      return this.$store.state.policiesData;
    },
    showCentrelinkCard() {
      if (this.isSitecoreExperienceEditorOn) {
        return true;
      }
      let isCentrelinkScheduleApplicable = false;
      if (this.policies) {
        isCentrelinkScheduleApplicable = this.policies.some((e) => {
          return e.centrelinkFlag === true;
        });
      }
      return isCentrelinkScheduleApplicable;
    },
  },
  methods: {
    async btnClicked() {
      if (this.isSitecoreExperienceEditorOn) {
        return;
      }
      try {
        this.loading = true;
        const response = await generateCentrelinkScheduleRequest();
        this.dialog = true;
      } catch (error) {
        apiErrorHelper(this.$router, error);
        this.loading = false;
      }
    },
    closeDialog() {
      this.loading = false;
      this.dialog = false;
    },
  },
};
